import { SkeletonFrame, SkeletonType } from '@nextgen-web-framework/all';
import { SkeletonLoaderProps } from './types/propTypes';
import styles from './SkeletonLoader.module.scss';

const SkeletonLoader = ({ noOfSkeletons = 1, heightValue = '24' }: SkeletonLoaderProps) => (
  <>
    {Array.from({ length: noOfSkeletons }).map((num, index) => (
      <div key={String(num)} className={styles['skeleton-loader-card']} data-testid={`skeleton-loader-card-${index}`}>
        <SkeletonFrame type={SkeletonType.FULL_WIDTH} heightValue={heightValue} />
        {noOfSkeletons === 1 && (
          <>
            <SkeletonFrame type={SkeletonType.FULL_WIDTH} heightValue={heightValue} />
            <SkeletonFrame type={SkeletonType.FULL_WIDTH} heightValue={heightValue} />
            <SkeletonFrame type={SkeletonType.FULL_WIDTH} heightValue={heightValue} />
          </>
        )}
      </div>
    ))}
  </>
);

export default SkeletonLoader;
